"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1208,12495],{

/***/ 982226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(208984);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 812809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Popover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(281668);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);
/* harmony import */ var _style_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(540999);
/* harmony import */ var _utils_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82389);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(806748);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledBottom = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ buttonAlign }) => `
  display: flex;
  justify-content: ${buttonAlign || "end"};
  margin-top: 0.75rem;
`);
const StyledButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z)`
  .button-text {
    color: ${({ theme }) => theme == null ? void 0 : theme.colors.white};
  }
`;
const Popover = (_a) => {
  var _b = _a, {
    children,
    placement = "auto",
    title,
    content,
    show = true,
    buttonText,
    onClickButton,
    showArrow = true,
    buttonAlign,
    buttonVariant = "default"
  } = _b, rest = __objRest(_b, [
    "children",
    "placement",
    "title",
    "content",
    "show",
    "buttonText",
    "onClickButton",
    "showArrow",
    "buttonAlign",
    "buttonVariant"
  ]);
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const { styles, attributes } = (0,react_popper__WEBPACK_IMPORTED_MODULE_3__/* .usePopper */ .D)(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      }
    ]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: { display: "flex" },
    ref: elementRef
  }, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_style_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PopoverWrapper */ .DD, __spreadValues(__spreadValues({
    ref: tooltipRef,
    style: __spreadValues({}, styles.popper),
    visibility: show
  }, attributes.popper), rest), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_style_es_js__WEBPACK_IMPORTED_MODULE_4__/* .StyledArrow */ .bC, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    className: (0,_utils_es_js__WEBPACK_IMPORTED_MODULE_5__/* .getArrowClassName */ .C)(attributes) || "",
    "data-placement": placement,
    backgroundColor: rest.backgroundColor
  }), typeof title === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .SubTitle */ .DK, {
    level: 4,
    weight: "medium",
    color: "white"
  }, title) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(title, {
    style: __spreadValues({ color: "white" }, title == null ? void 0 : title.props)
  }), typeof content === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .uT, {
    level: 1,
    weight: "regular",
    color: "placeholder"
  }, content) : content ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(content, {
    style: __spreadValues({ color: "#A7ABC3" }, content == null ? void 0 : content.props)
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null), !!buttonText && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBottom, {
    buttonAlign
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    variant: buttonVariant,
    size: "s",
    onClick: (e) => {
      e.stopPropagation();
      onClickButton == null ? void 0 : onClickButton();
    }
  }, buttonText))));
};




/***/ }),

/***/ 134128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(425336);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);



const Skeleton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Shape */ .b)`
  @keyframes loading {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  background-color: rgba(122, 121, 121, 0.11);
  -webkit-animation: loading 1.5s ease-in-out 0.5s infinite;
  animation: loading 1.5s ease-in-out 0.5s infinite;
  border-radius: 5px;
`;




/***/ }),

/***/ 383497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ChecklistOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ChecklistOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.88334 3.75C7.88334 3.33579 8.21913 3 8.63334 3H15.4289C15.8431 3 16.1789 3.33579 16.1789 3.75V3.97071H17.3118C18.8306 3.97071 20.0618 5.20193 20.0618 6.72071V18.2533C20.0618 19.7721 18.8306 21.0033 17.3118 21.0033H6.75C5.23122 21.0033 4 19.7721 4 18.2533V6.72071C4 5.20193 5.23122 3.97071 6.75 3.97071H7.88334V3.75ZM16.1789 7.63315V5.47071H17.3118C18.0022 5.47071 18.5618 6.03036 18.5618 6.72071V18.2533C18.5618 18.9437 18.0022 19.5033 17.3118 19.5033H6.75C6.05964 19.5033 5.5 18.9437 5.5 18.2533V6.72071C5.5 6.03036 6.05964 5.47071 6.75 5.47071H7.88334V7.63315C7.88334 8.04736 8.21913 8.38315 8.63334 8.38315H10.3322C10.7464 8.38315 11.0822 8.04736 11.0822 7.63315C11.0822 7.42585 11.3581 7.00247 12.0311 7.00247C12.7041 7.00247 12.98 7.42585 12.98 7.63315C12.98 8.04736 13.3158 8.38315 13.73 8.38315H15.4289C15.8431 8.38315 16.1789 8.04736 16.1789 7.63315ZM9.38334 4.5V6.88315H9.73243C10.0999 6.01694 11.0835 5.50247 12.0311 5.50247C12.9787 5.50247 13.9623 6.01694 14.3298 6.88315H14.6789V4.5H9.38334ZM15.6523 12.0465C15.9452 11.7536 15.9452 11.2788 15.6523 10.9859C15.3594 10.693 14.8845 10.693 14.5916 10.9859L11.3282 14.2493L10.1341 13.0552C9.84125 12.7623 9.36638 12.7623 9.07348 13.0552C8.78059 13.3481 8.78059 13.8229 9.07348 14.1158L10.7979 15.8403C10.9386 15.9809 11.1293 16.0599 11.3282 16.0599C11.5271 16.0599 11.7179 15.9809 11.8586 15.8403L15.6523 12.0465Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 512495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ FavouriteAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FavouriteAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.6362 5.75C16.6307 5.75 17.5345 6.15409 18.1899 6.80453C18.8431 7.45286 19.25 8.34674 19.25 9.33095C19.25 12.4832 14.6986 16.7712 12.6212 18.6318C12.444 18.7906 12.2221 18.8704 11.9999 18.8704C11.7775 18.8704 11.5553 18.7904 11.3778 18.6316C9.30052 16.7712 4.75 12.4832 4.75 9.33095C4.75 8.34674 5.15687 7.45286 5.81012 6.80453C6.46549 6.15409 7.36934 5.75 8.36379 5.75C9.63426 5.75 10.7192 6.417 11.3835 7.3758C11.6822 7.80686 11.8958 8.29678 12 8.8134C12.1041 8.29665 12.3178 7.80686 12.6165 7.3758C13.2808 6.417 14.365 5.75 15.6362 5.75Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 794898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ MenuOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const MenuOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 512 512" },
    child: [
      { tag: "title", attr: {}, child: [] },
      {
        tag: "line",
        attr: {
          x1: "88",
          y1: "152",
          x2: "424",
          y2: "152",
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          strokeWidth: "48px"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "88",
          y1: "256",
          x2: "424",
          y2: "256",
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          strokeWidth: "48px"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "88",
          y1: "360",
          x2: "424",
          y2: "360",
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          strokeWidth: "48px"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 546591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PromoOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PromoOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.19499 3C5.99608 3 5.80532 3.07902 5.66466 3.21967L3.21967 5.66466C3.07902 5.80532 3 5.99608 3 6.19499V11.085C3 11.2839 3.07902 11.4747 3.21967 11.6153L12.3884 20.784C12.6813 21.0769 13.1562 21.0769 13.4491 20.784L17.1166 17.1166L20.784 13.4491C21.0769 13.1562 21.0769 12.6813 20.784 12.3884L11.6153 3.21967C11.4747 3.07902 11.2839 3 11.085 3H6.19499ZM4.5 6.50565L6.50565 4.5H10.7743L19.1931 12.9187L16.0559 16.0559L12.9187 19.1931L4.5 10.7743V6.50565ZM7.86186 9.2514C7.86186 8.65286 8.34707 8.16765 8.94561 8.16765C9.54415 8.16765 10.0294 8.65286 10.0294 9.2514C10.0294 9.84994 9.54415 10.3351 8.94561 10.3351C8.34707 10.3351 7.86186 9.84994 7.86186 9.2514ZM8.94561 6.66765C7.51865 6.66765 6.36186 7.82444 6.36186 9.2514C6.36186 10.6784 7.51865 11.8351 8.94561 11.8351C10.3726 11.8351 11.5294 10.6784 11.5294 9.2514C11.5294 7.82444 10.3726 6.66765 8.94561 6.66765ZM11.3097 12.9996C11.0168 12.7067 10.5419 12.7067 10.249 12.9996C9.95613 13.2925 9.95613 13.7674 10.249 14.0603L12.3884 16.1996C12.6813 16.4925 13.1562 16.4925 13.449 16.1996C13.7419 15.9067 13.7419 15.4319 13.449 15.139L11.3097 12.9996ZM12.694 10.5545C12.9869 10.2616 13.4618 10.2616 13.7547 10.5545L15.8941 12.6939C16.187 12.9868 16.187 13.4616 15.8941 13.7545C15.6012 14.0474 15.1263 14.0474 14.8334 13.7545L12.694 11.6151C12.4011 11.3223 12.4011 10.8474 12.694 10.5545Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 775768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Logo = (_a) => {
  var _b = _a, {
    variant = "full",
    logoFull,
    logoLite,
    alt
  } = _b, props = __objRest(_b, [
    "variant",
    "logoFull",
    "logoLite",
    "alt"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadProps(__spreadValues({}, props), {
    src: variant === "full" ? logoFull : logoLite,
    alt
  }));
};




/***/ }),

/***/ 898815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MegaMenu; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(472522);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(788925);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenu = ({
  type,
  align = "left",
  menuItems
}) => {
  const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0);
  const verticalMenuWidth = "12.375rem";
  const horizontalMenuHeight = "3rem";
  const megaMenuHeight = "28.5rem";
  if (!menuItems.length)
    return null;
  const hideMenuPanel = () => {
    setActiveMenu(void 0);
  };
  const renderVerticalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      className: "vertical-mega-menu-wrapper",
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMegaMenu, {
      className: `vertical-mega-menu ${activeMenu ? "active" : ""}`,
      width: verticalMenuWidth,
      height: megaMenuHeight
    }, menuItems.slice(0, _MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__/* .MAX_MENU_ITEMS */ .K).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItem, {
      className: "vertical-mega-menu-item",
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItemImageMegaMenuWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_3__/* .EnhancedImage */ .N, {
      src: item.icon,
      height: "100%"
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Caption */ .YS, {
      level: 2,
      line: 1,
      style: { flex: 1 }
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuPanel, {
      className: `vertical-mega-menu-panel ${activeMenu ? "active" : ""}`,
      type,
      verticalMenuWidth,
      menu: menuItems,
      activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  const renderHorizontalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMegaMenu, {
      height: horizontalMenuHeight,
      align
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuItem, {
      height: horizontalMenuHeight,
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
      level: 2,
      line: 1,
      hoverColor: "primary500"
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuPanel, {
      type,
      className: activeMenu ? "active" : "",
      horizontalMenuHeight,
      menu: menuItems,
      activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  if (type === "vertical")
    return renderVerticalMegaMenu();
  return renderHorizontalMegaMenu();
};
const MegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  position: relative;
`;
const VerticalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__/* .MenuPanel */ .G)(({
  verticalMenuWidth,
  theme
}) => `
  position: absolute;
  top: 0;
  width: calc(75rem - ${verticalMenuWidth});
  left: ${verticalMenuWidth};
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.2s;
  visibility: hidden;
  opacity: 0;
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`);
const HorizontalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__/* .MenuPanel */ .G)(({
  horizontalMenuHeight,
  theme
}) => `
  position: absolute;
  left: 0;
  right: 0;
  top: ${horizontalMenuHeight};
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
  border-bottom-right-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  border-bottom-left-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));
  }
`);
const VerticalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, width, height }) => `
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  position: relative;
  overflow: hidden;
  width: ${width};
  height: ${height};
  z-index: 980;
  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`);
const HorizontalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, height, align }) => `
  height: ${height};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  width: 100%;
  overflow: hidden;
  ${align === "right" ? `display: flex;
        justify-content: flex-end;` : align === "space-between" ? `display: flex;
        justify-content: space-between;` : ""}
`);
const VerticalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme }) => `
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${theme == null ? void 0 : theme.spacing.s8};
  padding: 0 ${theme == null ? void 0 : theme.spacing.s8};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  overflow: hidden;
  &:hover {
    background-color: ${theme == null ? void 0 : theme.colors.primary50};
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const HorizontalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, height }) => `
  padding: 0 ${theme == null ? void 0 : theme.spacing.s12};
  height: ${height};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  &::after {
    content: '';
    height: 2px;
    background-color: ${theme == null ? void 0 : theme.colors.primary500};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease;
  }
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
    &::after {
      opacity: 1;
    }
  }
`);
const VerticalMenuItemImageMegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  width: 22px;
  height: 22px;
`;




/***/ }),

/***/ 472522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ MenuPanel; },
/* harmony export */   "K": function() { return /* binding */ MAX_MENU_ITEMS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);
/* harmony import */ var _helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(369985);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(675601);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(788925);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MEGA_MENU_BANNER_WIDTH = "14.625rem";
const MAX_MENU_ITEMS = 15;
const MenuPanel = ({
  menu,
  activeMenu,
  className,
  type,
  onClickMenuItem
}) => {
  var _a, _b, _c, _d;
  if (!menu.length)
    return null;
  const col = (item) => {
    return item.map((it, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuLv2, {
      key: it.name + `-${index}`,
      onClick: onClickMenuItem
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, it.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
      level: 1,
      line: 1,
      color: "primary500",
      marginBottom: "s8"
    }, it.name)), it.children.map((subItem, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, subItem.link), {
      key: index2
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, subItem.name)))));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuPanelWrapper, {
    isDisplay: !!activeMenu && (!!((_a = activeMenu.banner) == null ? void 0 : _a.src) || !!((_b = activeMenu.children) == null ? void 0 : _b.length)),
    className
  }, menu.slice(0, MAX_MENU_ITEMS).map((menuItem, index) => {
    const getMenuColumns = () => {
      var _a2;
      let totalCols = 6;
      if (type === "vertical")
        totalCols--;
      if ((_a2 = menuItem == null ? void 0 : menuItem.banner) == null ? void 0 : _a2.src)
        totalCols--;
      return totalCols;
    };
    const newMenu = (0,_helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_3__/* .convertMegaMenu */ .R)(menuItem, getMenuColumns());
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItemsWrapper, __spreadValues({
      key: index,
      isActive: menuItem === activeMenu
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      regionName: "megaMenuText",
      isTrackContent: true
    })), newMenu.map((menu2, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Column, {
      key: index2
    }, col(menu2.column))));
  }), ((_c = activeMenu == null ? void 0 : activeMenu.banner) == null ? void 0 : _c.src) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, (_d = activeMenu.banner) == null ? void 0 : _d.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__/* .EnhancedImage */ .N, {
    src: activeMenu.banner.src,
    width: MEGA_MENU_BANNER_WIDTH,
    height: "100%",
    googleImageParams: {
      width: 400
    },
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      regionName: "megaMenuBanner",
      isTrackContent: true
    })
  })));
};
const Text = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const MenuPanelWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme, isDisplay }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  display: ${isDisplay ? "flex" : "none"};
`);
const MenuItemsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme, isActive }) => `
  display: ${isActive ? "flex" : "none"};
  flex: 1;
  padding: ${theme == null ? void 0 : theme.spacing.s12};
`);
const MenuLv2 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  margin-bottom: 1.5rem;
`;
const Column = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  width: 25%;
  padding: 0 8px;
`;




/***/ }),

/***/ 241291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SelectionOption; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(285212);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4247);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_ICON_ACTIVE_SIZE = {
  [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs]: 14,
  [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.s */ .mO.s]: 14
};
const MAPPING_ACTIVE_BORDER = {
  [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs]: "0px 24px 24px 0px",
  [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.s */ .mO.s]: "0px 24px 24px 0px"
};
const SelectionOption = (_a) => {
  var _b = _a, {
    children,
    block = true,
    isActive = false,
    onClick,
    iconActiveSize = _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m,
    disabled = false
  } = _b, rest = __objRest(_b, [
    "children",
    "block",
    "isActive",
    "onClick",
    "iconActiveSize",
    "disabled"
  ]);
  const handleClick = () => {
    if (!disabled && typeof onClick === "function") {
      onClick(!isActive);
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    isActive,
    disabled,
    block,
    onClick: handleClick
  }, rest), typeof children === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    style: { textAlign: "center" },
    level: 1
  }, children) : children, !disabled && isActive && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActiveBorder, {
    iconActiveSize
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Checked, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .CheckOutlined */ .b, {
    size: MAPPING_ICON_ACTIVE_SIZE[iconActiveSize] || 20,
    color: "#ffffff"
  }))));
};
const getBorderColor = (props) => {
  return props.theme && props.isActive ? props.theme.colors.primary500 : "#e0e0e0";
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: #fff;
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.disabled ? "not-allowed" : "pointer"};
  ${props.block ? "width: 100%;" : ""}

  ${props.disabled ? `
    & > * {
      opacity: 0.4 !important;
    }
  ` : ""}
  &:hover {
    background: ${props.isActive || props.disabled ? "" : "#f3f3f3"} ;
  }
`);
const ActiveBorder = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ iconActiveSize, theme }) => `
  position: absolute;
  top: -1px;
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${MAPPING_ACTIVE_BORDER[iconActiveSize] || "0px 36px 36px 0px"};
  border-color: transparent ${theme == null ? void 0 : theme.colors.primary500} transparent transparent;
`);
const Checked = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].span`
  display: flex;
  position: absolute;
  top: -1px;
  right: -1px;
  z-index: 0;
`;




/***/ }),

/***/ 369985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ convertMegaMenu; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return [];
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      column: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      column: [...result[k].column, ...newArr[i].column]
    };
  }
  return result;
};




/***/ }),

/***/ 996199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ RegionPickerSuggestionPopover; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(812809);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(621655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);





const LocationOutlined = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(55050), __webpack_require__.e(88677), __webpack_require__.e(17709)]).then(__webpack_require__.bind(__webpack_require__, 588677)).then((mod)=>mod.LocationOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(588677)
            ]
    }
});
const StyledPopover = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Popover */ .J)((param)=>{
    let { minWidth  } = param;
    return "\n    box-shadow: 2px 4px 5px grey;\n    min-width: ".concat(minWidth, ";\n    z-index: 1060;\n  ");
});
const RegionPickerSuggestionPopover = (param)=>{
    let { active , onClose , isMobile , children ,  } = param;
    const { 0: show , 1: setShow  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (active) {
            setShow(true);
        }
    }, [
        active
    ]);
    const closePopover = ()=>{
        setShow(false);
        onClose();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledPopover, {
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
            align: "middle",
            justify: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                    flex: "5%",
                    paddingRight: "s8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationOutlined, {
                        size: 26,
                        color: "primary500"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
                    flex: "80%",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                        level: 1,
                        color: "textSecondary",
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("H\xe3y chọn địa chỉ cụ thể để ch\xfang t\xf4i cung cấp ch\xednh x\xe1c gi\xe1 v\xe0 khuyến m\xe3i.")
                    })
                })
            ]
        }),
        placement: isMobile ? "bottom-start" : "bottom-end",
        backgroundColor: "white",
        borderRadius: "l",
        borderStyle: "solid",
        borderWeight: "m",
        borderColor: "border",
        showArrow: isMobile ? true : false,
        buttonText: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Đ\xf3ng"),
        show: show,
        buttonAlign: "center",
        buttonVariant: "primary",
        padding: "s8",
        minWidth: isMobile ? "56vw" : "19rem",
        onClickButton: closePopover,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            onClick: closePopover,
            children: children
        })
    });
};


/***/ }),

/***/ 761035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ PopupRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(145000);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(188155);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(776609);
/* harmony import */ var components_mobile_organisms_DropDownRegionPicker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(716508);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(261431);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(676662);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(806748);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  margin-bottom: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 32px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 1060;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









const PopupRegionPicker = (param)=>{
    let { showPopup , selected , setSelected , terminals , locationOptions , onClosePopup , onSubmitNewLocation , activeLocation , title , useDropdownPicker  } = param;
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    if (isBot) {
        // disable region picker for bot
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (terminals === null || terminals === void 0 ? void 0 : terminals.length) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Modal */ .u, {
            size: "sm",
            show: showPopup,
            onHide: ()=>onClosePopup(),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .ModalHeader */ .x, {
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("Chọn khu vực giao h\xe0ng")
                }),
                !!activeLocation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseIcon, {
                    onClick: ()=>onClosePopup(),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .CloseOutlined */ .X, {
                        size: 32,
                        color: "#000000"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .ModalBody */ .f, {
                    children: useDropdownPicker ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    textAlign: "justify"
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImgWrapper, {
                                src: "https://shopfront-cdn.tekoapis.com/static/umbala/location.svg",
                                alt: "choose location"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_mobile_organisms_DropDownRegionPicker__WEBPACK_IMPORTED_MODULE_8__.DropDownRegionPicker, {
                                terminals: terminals,
                                onSelectTerminal: setSelected
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                variant: "primary",
                                size: "m",
                                block: true,
                                onClick: ()=>onSubmitNewLocation(),
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_5__.t)("X\xe1c nhận")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledPicker, {
                        options: locationOptions,
                        value: selected,
                        onChange: setSelected,
                        onSubmit: ()=>{
                            onSubmitNewLocation();
                        },
                        title: title
                    })
                })
            ]
        })
    });
};
const StyledPicker = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_10__/* .RegionPicker */ .H)(_templateObject());
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject1());
const ImgWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].img(_templateObject2());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .z)(_templateObject3());
const CloseIcon = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject4());


/***/ }),

/***/ 583880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ UserProfileHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(691568);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(134128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(339674);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(635412);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(983546);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(428247);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60862);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(749450);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(118042);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(670894);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 36px;\n  height: 36px;\n  margin: 5px 0 4px 0;\n  flex-shrink: 0;\n  &.vertical-avatar {\n    width: 30px;\n    height: 30px;\n    margin: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0.5rem;\n  display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 44px;\n  margin-right: 0.5rem;\n  img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  .name {\n    font-size: 1rem;\n    margin-bottom: 0;\n  }\n  .extra {\n    font-size: 0.9rem;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  height: 2rem;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  width: 250px;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 50%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}











const Avatar = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject());
const AvatarImage = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w)(_templateObject1());
const BriefUserPanel = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject2());
const UserAvatar = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject3());
const UserInfo = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject4());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)(_templateObject5());
const DropdownContent = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject6());
const UserName = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT)(_templateObject7());
const ProfileLink = (param)=>{
    let { icon , text , href , regionName , contentName , onClick  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .CustomLink */ .x, {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .ListContent */ .y, _objectSpread({
            icon: icon,
            label: text,
            onClick: onClick
        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
            isTrackContent: true,
            regionName,
            contentName
        })))
    });
};
const RoundSkeleton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Skeleton */ .O)(_templateObject8());
const NavigationButtonWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_style__WEBPACK_IMPORTED_MODULE_10__/* .NavigationButton */ .W)((props)=>"\n  width: ".concat(props.vertical ? "90" : "130", "px;\n  height:").concat(props.vertical ? "auto" : "45px", ";\n  ").concat(props.vertical ? "flex-direction: column;" : "", "\n"));
const UserProfilePlaceholder = (param)=>{
    let { vertical =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(NavigationButtonWrapper, {
        vertical: vertical,
        className: "button",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RoundSkeleton, {
                width: "36px",
                height: "36px"
            }),
            vertical ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Skeleton */ .O, {
                height: "0.75rem",
                width: "62px",
                className: "title"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Skeleton */ .O, {
                        height: "0.75rem",
                        width: "60px",
                        marginBottom: "s8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Skeleton */ .O, {
                        height: "0.75rem",
                        width: "90px"
                    })
                ]
            })
        ]
    });
};
const UserProfileMenu = (param)=>{
    let { profileLinks , userProfile  } = param;
    const { showModal  } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .useModal */ .d)();
    const { authService  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_12__/* .useAuth */ .aC)();
    const { notificationService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_13__/* .useServices */ .Su)();
    const { notificationAppId  } = (0,contexts__WEBPACK_IMPORTED_MODULE_14__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DropdownContent, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(BriefUserPanel, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserAvatar, {
                        children: userProfile.avatar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: userProfile.avatar,
                            alt: "Avatar"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_15__/* .AccountOutlined */ .y, {
                            size: 36,
                            color: "textSecondary"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UserInfo, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "name",
                                children: userProfile.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                className: "extra",
                                children: userProfile.email || userProfile.telephone
                            })
                        ]
                    })
                ]
            }),
            profileLinks && profileLinks.map((profileLink)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProfileLink, {
                    icon: profileLink.icon,
                    href: profileLink.href,
                    text: profileLink.text,
                    contentName: profileLink.contentName,
                    regionName: profileLink.regionName
                }, profileLink.href)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__/* .Shape */ .b, _objectSpreadProps(_objectSpread({
                padding: "s8"
            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "logOut"
            })), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                    onClick: ()=>{
                        showModal === null || showModal === void 0 ? void 0 : showModal({
                            title: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Đăng xuất"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Bạn c\xf3 chắc chắn muốn đăng xuất kh\xf4ng?")
                            }),
                            onOk: ()=>(0,helpers__WEBPACK_IMPORTED_MODULE_18__/* .onSignOut */ .U)(authService, notificationService, notificationAppId, window.location.origin),
                            cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Kh\xf4ng"),
                            okText: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("C\xf3")
                        });
                    },
                    variant: "primary",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Đăng xuất")
                })
            }))
        ]
    });
};
const UserProfileHeader = (param)=>{
    let { vertical =false , customProfile , profileLinks  } = param;
    const { user: userProfile , loading: profileLoading , authService  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_12__/* .useAuth */ .aC)();
    const onLogin = ()=>authService.login();
    if (customProfile) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: customProfile
    });
    if (profileLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserProfilePlaceholder, {
            vertical: vertical
        });
    }
    if (!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.userId)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(NavigationButtonWrapper, _objectSpreadProps(_objectSpread({
            vertical: vertical,
            onClick: onLogin,
            className: "button"
        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "loginIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_15__/* .AccountOutlined */ .y, {
                    size: 36,
                    color: "textSecondary"
                }),
                vertical ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
                    level: 2,
                    weight: "medium",
                    color: "textSecondary",
                    className: "title",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Đăng nhập")
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "ml-6 text-left",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Đăng nhập")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Đăng k\xfd")
                        })
                    ]
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__/* .Dropdown */ .L, {
        placement: "bottom",
        menu: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserProfileMenu, {
            profileLinks: profileLinks,
            userProfile: userProfile
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(NavigationButtonWrapper, _objectSpreadProps(_objectSpread({
            vertical: vertical,
            className: "button"
        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "profileIcon"
        })), {
            children: [
                userProfile.avatar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Avatar, {
                    className: vertical ? "vertical-avatar" : "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarImage, {
                        src: userProfile.avatar,
                        height: "100%",
                        "aria-label": "Current User Avatar"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_15__/* .AccountOutlined */ .y, {
                    size: 36,
                    color: "textSecondary"
                }),
                vertical ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserName, {
                    level: 2,
                    weight: "medium",
                    color: "textSecondary",
                    className: "title",
                    children: userProfile.name || userProfile.telephone
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "ml-12 text-left",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Xin ch\xe0o,")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserName, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            children: userProfile.name || userProfile.telephone
                        })
                    ]
                })
            ]
        }))
    });
};


/***/ }),

/***/ 770353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useIdentifiedPage = (className)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = document.createElement("div");
        node.className = className;
        node.style.display = "none";
        document.body.prepend(node);
        return ()=>node.remove();
    }, []);
};


/***/ }),

/***/ 642816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(353632);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(788813);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(479228);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);







const useRegionPicker = ()=>{
    var ref;
    const { isMobile , originalTerminal , clearCacheAfterSwitchLocation , isDmsFlow ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const terminals = originalTerminal || [];
    const selectedTerminal = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, isMobile);
    const selectedLocation = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, isMobile);
    const selectedTerminalId = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, isMobile);
    const enableLocationFeature = terminals.every((item)=>!!item.locationCode);
    const confirmedOptionIndex = terminals.findIndex((item)=>{
        if (enableLocationFeature) {
            return item.code === selectedTerminal && item.locationCode === selectedLocation;
        }
        return item.code === selectedTerminal;
    });
    const { 0: showRegionPopup , 1: setShowRegionPopup  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: selected , 1: setSelected  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
    const isDisableUserSelectLocation = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isDisableUserSelectLocationAction */ .z9)({
        isDmsFlow
    });
    const selectTerminal = (terminal)=>{
        var ref;
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, terminal.code, isMobile);
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, terminal === null || terminal === void 0 ? void 0 : (ref = terminal.id) === null || ref === void 0 ? void 0 : ref.toString(), isMobile);
        enableLocationFeature && (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, // remove after 284 --> ignore now
        // @ts-ignore
        terminal.locationCode, isMobile);
    };
    const onSubmitNewLocation = ()=>{
        selectTerminal(terminals[selected]);
        if (clearCacheAfterSwitchLocation) {
            (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .clearCacheAndReloadPage */ .w5)();
        } else {
            (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .reloadPage */ .sl)();
        }
    };
    const activeLocation = confirmedOptionIndex || confirmedOptionIndex === 0 ? terminals[confirmedOptionIndex] : undefined;
    const textMsg = "Vui l\xf2ng chọn khu vực để ch\xfang t\xf4i sắp xếp giao h\xe0ng cho bạn nhanh nhất.";
    // temporarily rely on the location object present terminal
    const useDropdownPicker = !!((ref = terminals[0]) === null || ref === void 0 ? void 0 : ref.location);
    const onClosePopup = ()=>{
        if (activeLocation) {
            setShowRegionPopup(false);
            setSelected(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // terminalId is a new key added later
        // we want to deprecate terminalCode
        // so for site without terminalId, prompt region picker
        const isTerminalSelected = !!selectedTerminal && !!selectedTerminalId && // ensure id and code are included in the workload configuration
        !!terminals.find((param)=>{
            let { code , id  } = param;
            return code === selectedTerminal && id === parseInt(selectedTerminalId);
        });
        // if terminals include just one element --> auto set this element
        if (terminals.length === 1 && !isTerminalSelected) {
            selectTerminal(terminals[0]);
        } else {
            // add check !activeLocation in case the list of locations changes
            // on server-side, and user
            setShowRegionPopup(enableLocationFeature ? !isTerminalSelected || !selectedLocation || !activeLocation : !isTerminalSelected);
        }
    }, [
        selectedTerminal,
        selectedLocation,
        selectedTerminalId
    ]);
    return {
        showPopup: !isDisableUserSelectLocation && showRegionPopup,
        setShowPopup: setShowRegionPopup,
        onOpenPopup: ()=>setShowRegionPopup(true),
        onClosePopup,
        selected,
        setSelected,
        terminals,
        locationOptions: terminals.map((el, index)=>({
                text: el.label,
                value: index
            })),
        onSubmitNewLocation,
        activeLocation,
        useDropdownPicker,
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .uT, {
            level: 1,
            children: textMsg
        }),
        isShowLocationIcon: !isDisableUserSelectLocation
    };
};


/***/ }),

/***/ 836816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LY": function() { return /* binding */ NavItem; },
  "vx": function() { return /* binding */ NavigationBar; },
  "dn": function() { return /* binding */ defaultNavItemDisplayConfig; },
  "fi": function() { return /* binding */ isVerticalNavItem; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ChecklistOutlined.es.js
var ChecklistOutlined_es = __webpack_require__(383497);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/PromoOutlined.es.js
var PromoOutlined_es = __webpack_require__(546591);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/OrderOutlined.es.js
var OrderOutlined_es = __webpack_require__(883594);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/LocationOutlined.es.js
var LocationOutlined_es = __webpack_require__(402374);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/TekoLink/TekoLink.es.js
var TekoLink_es = __webpack_require__(675601);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(139625);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/MegaMenu/MegaMenu.es.js
var MegaMenu_es = __webpack_require__(898815);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../packages/utils/dist/polyfill.es.js
var polyfill_es = __webpack_require__(593859);
// EXTERNAL MODULE: ./components/RegionPickerSuggestionPopover/RegionPickerSuggestionPopover.tsx
var RegionPickerSuggestionPopover = __webpack_require__(996199);
// EXTERNAL MODULE: ./components/desktop/organisms/UserProfileHeader.tsx
var UserProfileHeader = __webpack_require__(583880);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/DropdownMenu.es.js
var DropdownMenu_es = __webpack_require__(332762);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/Dropdown.es.js
var Dropdown_es = __webpack_require__(929556);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/DropdownToggle.es.js
var DropdownToggle_es = __webpack_require__(437753);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Logo/Logo.es.js
var Logo_es = __webpack_require__(775768);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/MenuOutlined.es.js
var MenuOutlined_es = __webpack_require__(794898);
;// CONCATENATED MODULE: ./components/desktop/organisms/LogoHeader.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  transform: translate(16px, 72px) !important;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 204px;\n  border-radius: 0.5rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 0.4rem;\n  color: inherit;\n  text-decoration: inherit;\n  :hover {\n    color: inherit;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











const LogoWrapper = emotion_styled_browser_esm["default"].div(_templateObject());
const StyledLogo = (0,emotion_styled_browser_esm["default"])(Logo_es/* Logo */.T)((param)=>{
    let { lite  } = param;
    return "\n  ".concat(lite ? "margin-right: 1rem; margin-left: 0.4rem;" : "", ";\n  -webkit-transition: all .15s ease-in-out;\n  -moz-transition: all .15s ease-in-out;\n  transition: all .15s ease-in-out;\n");
});
const MenuButton = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\nborder: 1px solid #e0e0e0;\ncursor: pointer;\nborder-radius: 4px;\nline-height: 1rem;\npadding: 0.4rem 0.75rem;\ntext-align: center;\ncolor: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.textSecondary, ";\n&:hover{\n  background: rgb(245, 245, 245);\n}\n");
});
const StyledDropdownMenu = (0,emotion_styled_browser_esm["default"])(DropdownMenu_es/* DropdownMenu */.h)(_templateObject1());
const MegaMenuWrapper = emotion_styled_browser_esm["default"].div(_templateObject2());
const DummyLink = emotion_styled_browser_esm["default"].a(_templateObject3());
const LogoHeader = (param)=>{
    let { isLite , dropdownOpen , toggle , menuItems  } = param;
    const globalData = (0,GlobalDataContext/* useGlobalData */.U5)();
    const { logo  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoWrapper, _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "logoPhongVu",
        target: "homepage"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                href: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
                    variant: isLite ? "square" : "full",
                    lite: isLite,
                    width: logo[isLite ? "lite" : "full"].width ? "".concat(logo[isLite ? "lite" : "full"].width, "px") : "auto",
                    height: "".concat(logo[isLite ? "lite" : "full"].height || 35, "px"),
                    alt: globalData.tenant,
                    logoFull: logo.full.path,
                    logoLite: logo.lite.path || logo.full.path
                })
            }),
            isLite && !!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown_es/* Dropdown */.L, {
                isOpen: dropdownOpen,
                toggle: toggle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle_es/* DropdownToggle */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuButton, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOutlined_es/* MenuOutlined */.y, {
                                    size: 20,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyLink, {
                                    onClick: (evt)=>{
                                        // the purpose of this link
                                        // is to let Google crawler to follow to the categories listing.
                                        // we prevent users from actually clicking here.
                                        evt.preventDefault();
                                        return false;
                                    },
                                    href: "/categories",
                                    children: (0,i18n.t)("Danh mục sản phẩm")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownMenu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
                                menuItems: menuItems,
                                type: "vertical"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/desktop/organisms/SearchBar.tsx + 3 modules
var SearchBar = __webpack_require__(88002);
// EXTERNAL MODULE: ./components/desktop/organisms/PopupRegionPicker.tsx
var PopupRegionPicker = __webpack_require__(761035);
// EXTERNAL MODULE: ./components/desktop/organisms/style.ts
var style = __webpack_require__(60862);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ./contexts/ThreeLevelLocationProvider/index.tsx + 8 modules
var ThreeLevelLocationProvider = __webpack_require__(779454);
// EXTERNAL MODULE: ./contexts/LocationProvider.tsx
var LocationProvider = __webpack_require__(158610);
// EXTERNAL MODULE: ./helpers/navigation-bar.tsx
var navigation_bar = __webpack_require__(382934);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./hooks/useLoyaltyMemberInfo.ts
var useLoyaltyMemberInfo = __webpack_require__(401192);
// EXTERNAL MODULE: ./hooks/useRegionPicker.tsx
var useRegionPicker = __webpack_require__(642816);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(504133);
// EXTERNAL MODULE: ./hooks/common.ts
var hooks_common = __webpack_require__(770353);
;// CONCATENATED MODULE: ./hooks/useLiteMode.tsx




const useLiteMode = function(ssrLiteMode) {
    let navOffsetTop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const router = (0,next_router.useRouter)();
    const { 0: isLite , 1: setIsLite  } = (0,react.useState)(ssrLiteMode);
    const { 0: dropdownOpen , 1: setDropdownOpen  } = (0,react.useState)(false);
    const listenScrollEvent = ()=>{
        const scrollOffSetTop = window.pageYOffset || document.documentElement.scrollTop;
        if ((0,common/* isHomepage */.GH)(router.asPath)) {
            if (scrollOffSetTop > navOffsetTop) {
                setIsLite(true);
            } else {
                setIsLite(false);
                setDropdownOpen(false);
            }
        } else {
            setIsLite(true);
        }
    };
    (0,react.useEffect)(()=>{
        setDropdownOpen(false);
    }, [
        router.query
    ]);
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", listenScrollEvent);
        return ()=>{
            window.removeEventListener("scroll", listenScrollEvent);
        };
    }, [
        router.asPath,
        navOffsetTop
    ]);
    (0,hooks_common/* useIsomorphicLayoutEffect */.L)(()=>{
        setIsLite(!(0,common/* isHomepage */.GH)(router.asPath));
    }, [
        router.asPath
    ]);
    const toggle = (0,react.useCallback)(()=>{
        setDropdownOpen(!dropdownOpen);
    }, [
        dropdownOpen
    ]);
    return {
        isLite,
        dropdownOpen,
        toggle
    };
};

// EXTERNAL MODULE: ./modules/cart/desktop/CartOverview.tsx
var CartOverview = __webpack_require__(236549);
// EXTERNAL MODULE: ./modules/notification/desktop/NotificationOverview.tsx
var NotificationOverview = __webpack_require__(268905);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx
function NavigationBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NavigationBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NavigationBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function NavigationBar_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function NavigationBar_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        NavigationBar_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function NavigationBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NavigationBar_templateObject() {
    const data = NavigationBar_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 550;\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-transition-delay: 0.1s;\n  transition-delay: 0.1s;\n"
    ]);
    NavigationBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavigationBar_templateObject1() {
    const data = NavigationBar_taggedTemplateLiteral([
        "\n  min-width: fit-content;\n"
    ]);
    NavigationBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavigationBar_templateObject2() {
    const data = NavigationBar_taggedTemplateLiteral([
        "\n  min-width: 0;\n  margin-top: 0.5rem;\n  margin-bottom: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    NavigationBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavigationBar_templateObject3() {
    const data = NavigationBar_taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1.25rem;\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    NavigationBar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


















const StyledNavigationBar = emotion_styled_browser_esm["default"].div((param)=>{
    let { lite , verticalNavItem  } = param;
    return "\n  @media print {\n    display: none;\n  }\n  background-color: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 1040;\n  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);\n  @media screen and (max-width: 767px) {\n    height: auto !important;\n  }\n\n  ".concat(lite && verticalNavItem ? "\n      min-width: 68px;\n      .title {\n        visibility: hidden;\n        height: 0;\n      }\n      .button {\n        gap: 0;\n      }\n    " : "", "\n");
});
const NavItem = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  cursor: pointer;\n  &:hover {\n    div {\n      color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, " !important;\n    }\n    path {\n      fill: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, " !important;\n    }\n  }\n");
});
const Overlay = emotion_styled_browser_esm["default"].div(NavigationBar_templateObject());
const StyledContainer = (0,emotion_styled_browser_esm["default"])(Container_es/* Container */.W)(NavigationBar_templateObject1());
const Keywords = emotion_styled_browser_esm["default"].p(NavigationBar_templateObject2());
const Keyword = (0,emotion_styled_browser_esm["default"])(TekoLink_es/* TekoLink */.A)(NavigationBar_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.neutral;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary500;
});
const isVerticalNavItem = (tenant)=>{
    switch(tenant){
        case "ipp":
            return true;
        default:
            return false;
    }
};
const defaultNavItemDisplayConfig = {
    order: false,
    promotion: false,
    login: true,
    cart: true,
    additional: undefined
};
const NavigationBar = (param)=>{
    let { showShippingFeeMiniCart =true , menuItems , liteLogo , displayConfig  } = param;
    displayConfig = NavigationBar_objectSpread({}, defaultNavItemDisplayConfig, displayConfig);
    const { partner , tenant , megaMenuType ="vertical" , alignMegaMenu ="left" , notificationAppId , popularKeywords , epicOmni948 , isDmsFlow , epicOmni1541 , epicOmni1538 , notFetchLoyaltyMemberInfoGlobally , displayNewLayout ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { user , authService  } = (0,context_es/* useAuth */.aC)();
    const { loyaltyMemberInfo  } = (0,useLoyaltyMemberInfo/* useLoyaltyMemberInfo */.h)(!notFetchLoyaltyMemberInfoGlobally);
    const profileLinks = (0,react.useMemo)(()=>{
        return (0,navigation_bar/* getNavItems */.r)({
            tenant,
            logged: !!(user === null || user === void 0 ? void 0 : user.userId),
            showLoyaltyItem: (notFetchLoyaltyMemberInfoGlobally ? !!(user === null || user === void 0 ? void 0 : user.loyaltyMemberId) : !!loyaltyMemberInfo) || !!epicOmni1538,
            showNotificationItem: !!notificationAppId,
            epicOmni948,
            epicOmni1546: true,
            displayNewLayout: displayNewLayout
        });
    }, [
        tenant,
        user,
        loyaltyMemberInfo,
        epicOmni948
    ]);
    const regionPickerProps = (0,useRegionPicker/* useRegionPicker */.j)();
    const region = regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.activeLocation;
    const { correctThreeLevelLocation , onOpenThreeLevelLocationPopup  } = (0,ThreeLevelLocationProvider/* useThreeLevelLocationContext */.u0)();
    const { setShowed: showLocationPopup , selectedLocation , showRegionPickerSuggestionPopover , onCloseRegionPickerSuggestionPopover , enabled: locationPickerEnabled ,  } = (0,LocationProvider/* useLocation */.T)();
    const onLogin = ()=>authService.login(window.location.href);
    const router = (0,next_router.useRouter)();
    const { 0: navOffsetTop , 1: setNavOffsetTop  } = (0,react.useState)(0);
    const { isLite , dropdownOpen , toggle  } = useLiteMode(!!liteLogo, navOffsetTop);
    const LoginIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileHeader/* UserProfileHeader */.F, {
        vertical: isVerticalNavItem(tenant),
        customProfile: !!partner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
            href: "/account/orders",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                className: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistOutlined_es/* ChecklistOutlined */.H, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: (0,i18n.t)("Quản l\xfd đơn h\xe0ng")
                    })
                ]
            })
        }) : undefined,
        profileLinks: profileLinks
    });
    const PromotionIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
        href: "/khuyen-mai",
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, NavigationBar_objectSpreadProps(NavigationBar_objectSpread({
            className: "button",
            style: isVerticalNavItem(tenant) ? {
                flexDirection: "column"
            } : {
                flexDirection: "row"
            }
        }, (0,helper_es/* getTrackingData */.O5)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "promotionLandingIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoOutlined_es/* PromoOutlined */.G, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "title",
                    children: (0,i18n.t)("Khuyến m\xe3i")
                })
            ]
        }))
    });
    const OrderIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, NavigationBar_objectSpreadProps(NavigationBar_objectSpread({
        className: "button",
        onClick: ()=>{
            if (!(user === null || user === void 0 ? void 0 : user.userId)) {
                onLogin();
            } else {
                router.push("/account/orders");
            }
        },
        style: isVerticalNavItem(tenant) ? {
            flexDirection: "column"
        } : {
            flexDirection: "row"
        }
    }, (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "orderIcon"
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderOutlined_es/* OrderOutlined */.y, {
                size: 36,
                color: "textSecondary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "title",
                children: (0,i18n.t)("Đơn h\xe0ng")
            })
        ]
    }));
    const NotificationIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationOverview/* NotificationOverview */.C, {
        title: isVerticalNavItem(tenant)
    });
    const CartIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview/* CartOverview */.T, {
        showShippingFeeMiniCart: showShippingFeeMiniCart,
        vertical: isVerticalNavItem(tenant)
    });
    const RegionPickerIcon = (param)=>{
        let { locationName  } = param;
        const showRegionPickerModal = ()=>{
            if (flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284) {
                showLocationPopup === null || showLocationPopup === void 0 ? void 0 : showLocationPopup(true);
            } else {
                regionPickerProps.onOpenPopup();
            }
        };
        // Don't show this icon on the server side
        if (!(0,helpers/* isServerless */.ep)()) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerSuggestionPopover/* RegionPickerSuggestionPopover */.R, {
            active: !!showRegionPickerSuggestionPopover,
            onClose: onCloseRegionPickerSuggestionPopover !== null && onCloseRegionPickerSuggestionPopover !== void 0 ? onCloseRegionPickerSuggestionPopover : ()=>{},
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavItem, NavigationBar_objectSpreadProps(NavigationBar_objectSpread({
                onClick: showRegionPickerModal
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "location"
            })), {
                className: "att-home-page-delivery-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                color: "textSecondary",
                                children: (0,i18n.t)("Xem sản phẩm tại")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                level: 2,
                                weight: "medium",
                                color: "textSecondary",
                                line: 1,
                                children: locationName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                        size: 24,
                        color: "textSecondary"
                    })
                ]
            }))
        });
    };
    const ThreeLevelLocationPickerIcon = ()=>{
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerSuggestionPopover/* RegionPickerSuggestionPopover */.R, {
            active: !!showRegionPickerSuggestionPopover,
            onClose: onCloseRegionPickerSuggestionPopover !== null && onCloseRegionPickerSuggestionPopover !== void 0 ? onCloseRegionPickerSuggestionPopover : ()=>{},
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavItem, {
                onClick: onOpenThreeLevelLocationPopup,
                className: "att-home-page-delivery-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                color: "textSecondary",
                                children: (0,i18n.t)("Xem sản phẩm tại")
                            }),
                            !!correctThreeLevelLocation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                level: 2,
                                weight: "medium",
                                color: "textSecondary",
                                maxWidth: "128px",
                                line: 1,
                                children: [
                                    correctThreeLevelLocation.ward.label,
                                    ",",
                                    " ",
                                    (ref = correctThreeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.label,
                                    ",",
                                    " ",
                                    correctThreeLevelLocation.province.label
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                level: 2,
                                weight: "medium",
                                color: "textSecondary",
                                children: (0,i18n.t)("Chưa c\xf3 địa chỉ được chọn")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                        size: 24,
                        color: "textSecondary"
                    })
                ]
            })
        });
    };
    const getNavMenuByDisplayConfig = ()=>{
        var ref;
        const { order , promotion , login , cart , additional  } = displayConfig || {};
        const navMenu = [];
        if (promotion) navMenu.push(PromotionIcon);
        if (order) navMenu.push(OrderIcon);
        if (login) navMenu.push(LoginIcon);
        if (notificationAppId) navMenu.push(NotificationIcon);
        if (cart) navMenu.push(CartIcon);
        if (locationPickerEnabled) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.locationName
            }));
        } else if ((regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.isShowLocationIcon) && region && (regionPickerProps === null || regionPickerProps === void 0 ? void 0 : (ref = regionPickerProps.terminals) === null || ref === void 0 ? void 0 : ref.length) > 1) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: region === null || region === void 0 ? void 0 : region.label
            }));
        }
        if (additional) navMenu.push(additional);
        if (!isDmsFlow && !!epicOmni1541) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeLevelLocationPickerIcon, {}));
        }
        return navMenu;
    };
    const { 0: navItems , 1: setNavItems  } = (0,react.useState)(getNavMenuByDisplayConfig());
    (0,react.useEffect)(()=>{
        setNavItems(getNavMenuByDisplayConfig());
    }, [
        user === null || user === void 0 ? void 0 : user.userId,
        selectedLocation,
        loyaltyMemberInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            dropdownOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavigationBar, {
                lite: isLite,
                verticalNavItem: isVerticalNavItem(tenant),
                id: "mainNavigationBar",
                ref: (navRef)=>{
                    (0,polyfill_es/* requestIdleCallback */.Kk)((deadline)=>{
                        if (navRef && deadline.timeRemaining() > 0) {
                            const { scrollTop  } = document.documentElement;
                            setNavOffsetTop(scrollTop % Topbar_es/* TOPBAR_HEIGHT */.n);
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                        justify: "center",
                        paddingLeft: "s8",
                        paddingRight: "s8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            gutter: 16,
                            align: "middle",
                            style: NavigationBar_objectSpreadProps(NavigationBar_objectSpread({}, megaMenuType === "vertical" && isVerticalNavItem(tenant) && isLite ? {
                                height: "72px"
                            } : !(popularKeywords === null || popularKeywords === void 0 ? void 0 : popularKeywords.length) ? {
                                height: "88px"
                            } : {
                                height: "112px"
                            }), {
                                minWidth: 0,
                                width: "75rem"
                            }),
                            wrap: false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "0 0 auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoHeader, {
                                        isLite: megaMenuType === "vertical" && ( true ? isLite : 0),
                                        dropdownOpen: dropdownOpen,
                                        toggle: toggle,
                                        // Only show mega menu dropdown on type vertical
                                        menuItems: megaMenuType === "vertical" ? menuItems : []
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                                    flex: "1 1 auto",
                                    style: {
                                        paddingTop: (popularKeywords === null || popularKeywords === void 0 ? void 0 : popularKeywords.length) ? "1.75rem" : "0",
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar/* SearchBar */.E, {}),
                                        !!(popularKeywords === null || popularKeywords === void 0 ? void 0 : popularKeywords.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Keywords, {
                                            children: popularKeywords.map((param, i)=>/*#__PURE__*/ {
                                                let { keyword , link  } = param;
                                                return (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        i > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: "\xa0\xa0\xa0"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Keyword, {
                                                            href: link,
                                                            children: keyword
                                                        })
                                                    ]
                                                }, keyword);
                                            })
                                        })
                                    ]
                                }),
                                navItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        flex: "0 0 auto",
                                        children: item
                                    }, index))
                            ]
                        })
                    }),
                    megaMenuType === "horizontal" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                                gap: 0,
                                color: "divider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        span: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
                                            type: "horizontal",
                                            align: alignMegaMenu,
                                            menuItems: menuItems !== null && menuItems !== void 0 ? menuItems : []
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !(flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupRegionPicker/* PopupRegionPicker */.H, NavigationBar_objectSpread({}, regionPickerProps))
        ]
    });
};


/***/ })

}]);